export function GoogleIcon() {
	return (
		<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.02845 14.9322L4.4068 12.3602C4.21363 11.7761 4.10917 11.1512 4.10917 10.5012C4.10917 9.85127 4.21363 9.22638 4.4068 8.64227L1.02845 6.07031C0.369549 7.40397 0 8.90756 0 10.5012C0 12.0949 0.369549 13.5985 1.02845 14.9322Z"
				fill="#FBBC05"
			/>
			<path
				d="M4.40764 8.64102C5.1871 6.28407 7.41103 4.59091 10.0455 4.59091C11.4609 4.59091 12.7393 5.09091 13.7437 5.90909L16.6658 3C14.8852 1.45455 12.6023 0.5 10.0455 0.5C6.07608 0.5 2.66313 2.7621 1.0293 6.06906L4.40764 8.64102Z"
				fill="#EA4335"
			/>
			<path
				d="M10.0449 20.5009C6.07439 20.5009 2.66065 18.2375 1.02734 14.9291L4.40431 12.3516C5.18129 14.7128 7.40735 16.41 10.0449 16.41C11.3355 16.41 12.4791 16.1074 13.3847 15.5384L16.5919 18.0104C14.8362 19.6355 12.4949 20.5009 10.0449 20.5009Z"
				fill="#34A853"
			/>
			<path
				d="M10.0449 8.67969H19.4047C19.5417 9.2706 19.633 9.90696 19.633 10.4979C19.633 13.7572 18.4353 16.3011 16.592 18.0074L13.3847 15.5354C14.4334 14.8765 15.163 13.8604 15.4325 12.5433H10.0449V8.67969Z"
				fill="#4285F4"
			/>
		</svg>
	);
}
